import { configure } from "mobx";
import { createContext, useContext } from "react";
import EmailConfigStore from "./emailConfigStore";
import MachineConfigStore from "./machineConfigStore";
configure({ enforceActions: "always" });

interface Store {
  emailConfigStore: EmailConfigStore;
  machineConfigStore: MachineConfigStore
}

export const store: Store = {
  emailConfigStore: new EmailConfigStore(),
  machineConfigStore: new MachineConfigStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
